import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  data: {
    date: dayjs().format("YYYY-MM-DD"),
    weight: null,
    neck_circumference: null,
    umbilical_circumference: null,
    hips_circumference: null,
    middle_thigh_circumference: null,
    arm_circumference: null,
  },
};

const diarySlice = createSlice({
  name: "diary",
  initialState,
  reducers: {
    resetDiaryState: (state, action) => {
      state.data = {
        ...initialState.data,
        date: action.payload,
      };
    },
    updateMeasure: (state, action) => {
      state.data[action.payload.key] = action.payload.value;
    },
    updateMeasures: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { resetDiaryState, updateMeasure, updateMeasures } =
  diarySlice.actions;
export default diarySlice.reducer;
